export default __webpack_public_path__ + "static/1_orange-8fe3716f2c91bf90dd382f3b9a69aa50.svg";